<script lang="ts" setup>
import { ref } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import BroadcastSend from "~/components/broadcast/steps/BroadcastSend.vue";
import { useBroadcast } from "~/stores/broadcast.store";

const broadcastStore = useBroadcast();
const pageLoading = ref(false);

onBeforeRouteLeave(() => broadcastStore.resetError());
</script>

<template>
  <BroadcastSentModal />
  <ConfirmQueueSend />
  <PreviewSendModal />

  <div class="layout">
    <div class="c-table">
      <BasePreloader v-if="pageLoading" class="absolute m-auto inset-0" />
      <BroadcastSend v-else />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-areas: "c-table";
  height: 100%;
  grid-template-rows: 1fr;
  gap: $items-spacing;

  .next {
    grid-area: next;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px $items-spacing;
    gap: $items-spacing;

    background: #ffffff;
    border-top: 1px solid #e0e0e0;

    .next-btn {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 0px;
      gap: $items-spacing;

      :deep(.button) {
        padding: 10px 18px;
      }
    }
  }

  .c-table {
    grid-area: c-table;
    overflow-x: auto;
    height: 100%;
    position: relative;

    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar {
      width: 0;
    }
  }
}

.layout-empty {
  display: flex;
  height: 100%;
  gap: $items-spacing;
}
</style>
